module.exports = __webpack_public_path__ + "static/img/stay-option-icon-amenity.230d2bd5.svg";